/* eslint-disable no-unused-vars */
import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import AppRoutes from './Routes'
import { ActionCreators } from '../../../redux/actions'
const App = (props) => {
  console.log("🔥 APP.JS LOADED");


  return (
    <>
      <div className="App">
        <AppRoutes />
      </div>
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
})

export default connect(null, mapDispatchToProps)(App)
